import React, { useEffect, useState, createElement } from 'react';
import { Check, X, ChevronDown, ChevronUp, ArrowRight, Star, Clock, Smartphone, TrendingUp, XIcon } from 'lucide-react';
const CTAButton = ({
  children,
  className = '',
  href = 'https://www.cocinandoconjoha.com/cart/47735075963045:1',
  external = true
}: {
  children: React.ReactNode;
  className?: string;
  href?: string;
  external?: boolean;
}) => <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} onClick={() => {
  if (external && typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'AddToCart', {
      content_name: 'El Paso a Paso del Medio Millón',
      content_type: 'product',
      value: 8690,
      currency: 'ARS'
    });
  }
}} className={`relative w-full md:w-auto bg-gold hover:bg-gold-hover text-white font-extrabold py-5 px-10 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1.5 hover:scale-105 flex items-center justify-center gap-3 text-xl tracking-wide animate-cta-pulse no-underline ${className}`} data-id="element-0">
    {children}
    <ArrowRight className="w-6 h-6" data-id="element-1" />
  </a>;
const Divider = () => <div className="flex justify-center py-12" data-id="element-2">
    <div className="w-24 h-[1px] bg-gold/40" data-id="element-3"></div>
  </div>;
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1279876863600581');
      f.fbq('track', 'PageView');
    }
  }, []);
  const faqs = [{
    q: '¿Necesito horno?',
    a: 'No, la mayoría son postres fríos que se ensamblan.'
  }, {
    q: '¿Cuánta plata necesito para empezar?',
    a: 'Con $10.000 o menos comprás tus primeros insumos y vasos.'
  }, {
    q: '¿Tengo que saber decorar?',
    a: 'No, el diseño del vaso hace el 90% del trabajo por vos.'
  }, {
    q: '¿Sirve para todo el país?',
    a: 'Sí.'
  }];
  return <div className="min-h-screen bg-cream selection:bg-gold/30 selection:text-white" data-id="element-4">
      {/* HERO SECTION */}
      <header className="pt-16 pb-12 md:pt-24 md:pb-16 px-4 max-w-6xl mx-auto" data-id="element-5">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-6">
          <div className="flex-1 text-center lg:text-left" data-id="element-7">
            <div className="inline-block bg-gold/10 border border-gold/30 text-chocolate px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide mb-6" data-id="element-8">
              NUEVO LANZAMIENTO
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-9">
              EL PASO A PASO DEL MEDIO MILLÓN: <br data-id="element-10" />
              <span className="text-gold" data-id="element-11">TU NEGOCIO DE POSTRES EN VASO</span>
            </h1>
            <h2 className="text-xl md:text-2xl text-warm-dark font-medium leading-relaxed mb-8" data-id="element-12">
              Genera $500.000 pesos por mes con "Postres de Vitrina" que se
              venden solos, sin usar el horno y desde tu propia cocina.
            </h2>
            <CTAButton href="#oferta" external={false} data-id="element-13">
              ¡QUIERO EMPEZAR MI NEGOCIO AHORA!
            </CTAButton>
            <p className="mt-4 text-sm text-warm-dark/70 flex items-center justify-center lg:justify-start gap-2" data-id="element-14">
              <Star className="w-4 h-4 text-gold fill-gold" data-id="element-15" />
              Acceso inmediato tras el pago
            </p>
          </div>
          <div className="flex-1 relative w-full max-w-lg mx-auto lg:max-w-none" data-id="element-16">
            <div className="absolute inset-0 bg-gold/20 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-17"></div>
            <img src="https://cdn.magicpatterns.com/uploads/gWojS3YoiJiDdax4bHWMvy/NUEVO_PRODUCTO.png" alt="Ebook El Pack de los 500K en tablet y celular con postres en vaso" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-18" />
          </div>
        </div>
      </header>

      <Divider data-id="element-19" />

      {/* OPENING HOOK */}
      <section className="py-12 px-4 max-w-3xl mx-auto text-center" data-id="element-20">
        <p className="text-xl md:text-2xl leading-relaxed font-medium text-chocolate" data-id="element-21">
          ¿Estás cansada de que la plata no alcance y de sentir que para
          emprender necesitás una fortuna en máquinas o cursos caros? Existe una
          forma de transformar solo un par de billetes de mil en un ingreso
          semanal real de $125.000 o más, vendiendo el producto con mayor
          rotación de Argentina hoy:{' '}
          <span className="font-bold border-b-2 border-gold" data-id="element-22">
            el postre en vaso.
          </span>
        </p>
      </section>

      {/* THE PROBLEM */}
      <section className="py-16 px-4 bg-white/50" data-id="element-23">
        <div className="max-w-4xl mx-auto" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-25">
            El error que te está costando dinero
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-26">
            <div className="bg-cream p-8 rounded-2xl border border-gold/20 shadow-sm" data-id="element-27">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6" data-id="element-28">
                <X className="w-6 h-6 text-red-600" data-id="element-29" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-30">
                El problema de las tortas
              </h3>
              <p className="text-warm-dark leading-relaxed" data-id="element-31">
                La mayoría de las mujeres que intentan vender comida fallan
                porque eligen productos difíciles. Las tortas enteras son caras
                de producir, se rompen en el envío y si no las vendés en 24
                horas, tirás la mercadería y tu dinero a la basura.
              </p>
            </div>
            <div className="bg-cream p-8 rounded-2xl border border-gold/20 shadow-sm" data-id="element-32">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-33">
                <TrendingUp className="w-6 h-6 text-green-600" data-id="element-34" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-35">
                La oportunidad del vaso
              </h3>
              <p className="text-warm-dark leading-relaxed" data-id="element-36">
                En el contexto actual, la gente no tiene $30.000 para una torta
                entera, pero todos tienen $6.500 para un gusto personal al salir
                del trabajo o después de cenar. Si no estás ofreciendo porciones
                individuales, estás dejando toda la plata sobre la mesa.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WHY WHAT YOU TRIED DIDN'T WORK */}
      <section className="py-16 px-4 max-w-4xl mx-auto" data-id="element-37">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-38">
          Por qué lo que intentaste antes no funcionó
        </h2>
        <div className="space-y-6" data-id="element-39">
          {['Los cursos de pastelería tradicional te enseñan técnicas francesas que llevan horas, pero no te enseñan cómo ganar plata hoy.', 'Intentar vender por Instagram sin una estrategia de "escasez" hace que tus fotos pasen desapercibidas.', 'Calcular los precios "a ojo" en un país con inflación hace que termines trabajando gratis sin darte cuenta.'].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-gold/10" data-id="element-40">
              <div className="mt-1 flex-shrink-0" data-id="element-41">
                <X className="w-6 h-6 text-red-500" data-id="element-42" />
              </div>
              <p className="text-lg text-warm-dark" data-id="element-43">{item}</p>
            </div>)}
        </div>
      </section>

      {/* THE UNIQUE MECHANISM */}
      <section className="py-20 px-4 bg-chocolate text-white" data-id="element-44">
        <div className="max-w-4xl mx-auto text-center" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gold-light" data-id="element-46">
            El "Efecto Vitrina"
          </h2>
          <p className="text-xl leading-relaxed mb-8 opacity-90" data-id="element-47">
            Mi sistema se basa en el "Efecto Vitrina". No cocinamos, ensamblamos
            capas de alto impacto visual que disparan el deseo de compra
            inmediato.
          </p>
          <p className="text-xl leading-relaxed opacity-90" data-id="element-48">
            Usando el{' '}
            <strong className="text-gold-light font-normal" data-id="element-49">
              Método de Capas Optimizadas
            </strong>
            , lográs que un postre que te costó $1.800 se vea (y se venda) como
            un producto premium de $6.500. Es ingeniería de ventas aplicada a la
            repostería casera.
          </p>
        </div>
      </section>

      {/* WHAT YOU GET */}
      <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-50">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-51">
          ¿Qué incluye El Paso a Paso para Ganar Medio Millón?
        </h2>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-52">
          {[{
          title: 'Guía Maestra "Postres de Oro"',
          desc: 'El paso a paso para montar tu negocio en 48 horas.'
        }, {
          title: 'Recetario de los 10 Intocables',
          desc: 'Las fórmulas exactas de Chocotorta, Oreo, Lemon Pie y más.'
        }, {
          title: 'Calculadora de Costos Argentina',
          desc: 'Para que sepas exactamente cuánto ganar peso por peso.'
        }, {
          title: 'Estrategia Venta Flash',
          desc: 'Cómo agotar tu stock en 24 horas usando solo WhatsApp.'
        }].map((item, i) => <div key={i} className="flex gap-4 p-6 bg-white rounded-xl border-l-4 border-gold shadow-sm" data-id="element-53">
              <div className="flex-shrink-0" data-id="element-54">
                <Check className="w-6 h-6 text-gold" data-id="element-55" />
              </div>
              <div data-id="element-56">
                <h3 className="font-bold text-lg mb-2 text-chocolate" data-id="element-57">
                  {item.title}
                </h3>
                <p className="text-warm-dark" data-id="element-58">{item.desc}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-59">
          <CTAButton href="#oferta" external={false} data-id="element-60">
            ACCEDER AL PACK COMPLETO
          </CTAButton>
        </div>
      </section>

      {/* WHO THIS IS FOR / NOT FOR */}
      <section className="py-16 px-4 bg-white/50" data-id="element-61">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-62">
          {/* FOR */}
          <div className="bg-cream p-8 rounded-2xl border border-gold/30" data-id="element-63">
            <h3 className="text-2xl font-bold mb-6 text-chocolate flex items-center gap-2" data-id="element-64">
              <Check className="w-6 h-6 text-green-600" data-id="element-65" />
              Esto ES para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-66">
              {['Mujeres que necesitan generar dinero extra urgente para la casa.', 'Mamás que quieren trabajar desde su cocina sin descuidar a sus hijos.', 'Emprendedoras que ya cocinan pero no logran que el negocio sea rentable.', 'Personas sin conocimientos previos de cocina que saben seguir instrucciones simples.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-67">
                  <div className="w-1.5 h-1.5 rounded-full bg-gold mt-2.5 flex-shrink-0" data-id="element-68"></div>
                  <span className="text-warm-dark" data-id="element-69">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NOT FOR */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-70">
            <h3 className="text-2xl font-bold mb-6 text-gray-400 flex items-center gap-2" data-id="element-71">
              <X className="w-6 h-6 text-red-400" data-id="element-72" />
              Esto NO es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-73">
              {['Personas que buscan "dinero fácil" sin ensuciarse las manos con un poco de dulce de leche.', 'Reposteros profesionales que buscan técnicas de alta cocina (esto es para ganar plata, no para ganar premios).', 'Gente que no está dispuesta a publicar una foto en su WhatsApp.'].map((item, i) => <li key={i} className="flex items-start gap-3 opacity-70" data-id="element-74">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2.5 flex-shrink-0" data-id="element-75"></div>
                  <span className="text-warm-dark" data-id="element-76">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-77">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-78">
          Cómo funciona en 3 pasos simples
        </h2>
        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-79">
          <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-[2px] bg-gold/20 -z-10" data-id="element-80"></div>

          <div className="text-center" data-id="element-81">
            <div className="w-16 h-16 mx-auto bg-gold text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-lg" data-id="element-82">
              1
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-83">Descargás</h3>
            <p className="text-warm-dark" data-id="element-84">
              Descargás el Ebook PDF y elegís 2 de las 10 recetas maestras.
            </p>
          </div>

          <div className="text-center" data-id="element-85">
            <div className="w-16 h-16 mx-auto bg-gold text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-lg" data-id="element-86">
              2
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-87">Armás</h3>
            <p className="text-warm-dark" data-id="element-88">
              Armás tus primeros 10 vasos usando la guía de ensamblado rápido.
            </p>
          </div>

          <div className="text-center" data-id="element-89">
            <div className="w-16 h-16 mx-auto bg-gold text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-lg" data-id="element-90">
              3
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-91">Cobrás</h3>
            <p className="text-warm-dark" data-id="element-92">
              Copiás y pegás mi mensaje de "Venta Flash" en tu círculo cercano y
              empezás a cobrar.
            </p>
          </div>
        </div>
      </section>

      {/* PROOF / BELIEVABILITY */}
      <section className="py-16 px-4 bg-gold/10 border-y border-gold/20" data-id="element-93">
        <div className="max-w-3xl mx-auto text-center" data-id="element-94">
          <div className="flex justify-center mb-6" data-id="element-95">
            <Clock className="w-12 h-12 text-gold" data-id="element-96" />
          </div>
          <p className="text-xl md:text-2xl font-medium leading-relaxed text-chocolate" data-id="element-97">
            En solo 1 día, siguiendo este sistema, habrás recuperado el valor de
            esta guía y tendrás tu primera tanda de clientes fijos que te
            pedirán postres todos los fines de semana. No necesitás seguidores,
            solo necesitás un par de vasos y ganas de arrancar.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-98">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-99">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-100">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl border border-gold/20 overflow-hidden" data-id="element-101">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenFaq(openFaq === i ? null : i)} data-id="element-102">
                <span className="font-bold text-lg text-chocolate" data-id="element-103">
                  {faq.q}
                </span>
                {openFaq === i ? <ChevronUp className="w-5 h-5 text-gold flex-shrink-0" data-id="element-104" /> : <ChevronDown className="w-5 h-5 text-gold flex-shrink-0" data-id="element-105" />}
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === i ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-106">
                <p className="text-warm-dark" data-id="element-107">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* OFFER + PRICE BLOCK & FINAL CTA */}
      <section id="oferta" className="py-20 px-4 bg-chocolate text-white text-center scroll-mt-8" data-id="element-108">
        <div className="max-w-3xl mx-auto" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gold-light" data-id="element-110">
            Tu oportunidad empieza hoy
          </h2>
          <div className="bg-white/5 border border-gold/30 rounded-2xl p-8 md:p-12 backdrop-blur-sm" data-id="element-111">
            <p className="text-xl mb-6" data-id="element-112">
              Hoy podés llevarte este Ebook PDF para ganar tus primeros $500.000
              completo por solo:
            </p>
            <div className="inline-block bg-gold text-white font-serif px-8 py-4 rounded-xl mb-6" data-id="element-113">
              <span className="text-2xl md:text-3xl text-white/50 line-through block mb-1" data-id="element-114">
                $25.000
              </span>
              <span className="text-5xl md:text-6xl font-bold" data-id="element-115">$8.690 ARS</span>
            </div>
            <p className="text-lg opacity-90 mb-10 max-w-xl mx-auto" data-id="element-116">
              Menos de lo que vale un solo combo de hamburguesa, pero con el
              potencial de generar medio millón al mes.
            </p>
            <CTAButton className="w-full md:w-auto mx-auto text-xl py-5 px-10" data-id="element-117">
              ¡QUIERO EMPEZAR MI NEGOCIO AHORA!
            </CTAButton>
            <p className="mt-6 text-sm opacity-70 flex items-center justify-center gap-2" data-id="element-118">
              <Smartphone className="w-4 h-4" data-id="element-119" />
              Acceso inmediato tras el pago. Empezá a vender HOY mismo.
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 text-center text-warm-dark/60 text-sm" data-id="element-120">
        <p className="mb-3" data-id="element-121">
          © {new Date().getFullYear()} El Paso a Paso del Medio Millón. Todos
          los derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-122">
          <button onClick={() => setModal('privacy')} className="underline hover:text-gold transition-colors" data-id="element-123">
            Política de Privacidad
          </button>
          <span data-id="element-124">·</span>
          <button onClick={() => setModal('terms')} className="underline hover:text-gold transition-colors" data-id="element-125">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* LEGAL MODAL */}
      {modal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={() => setModal(null)} data-id="element-126">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-127">
            <button onClick={() => setModal(null)} className="absolute top-4 right-4 text-warm-dark/60 hover:text-gold transition-colors" aria-label="Cerrar" data-id="element-128">
              <XIcon className="w-6 h-6" data-id="element-129" />
            </button>

            {modal === 'privacy' && <div className="space-y-4 text-warm-dark" data-id="element-130">
                <h2 className="text-2xl font-bold text-chocolate mb-6" data-id="element-131">
                  Política de Privacidad
                </h2>
                <p data-id="element-132">
                  <strong data-id="element-133">Última actualización:</strong> Abril 2026
                </p>
                <p data-id="element-134">
                  En El Paso a Paso del Medio Millón, nos comprometemos a
                  proteger tu privacidad. Esta política describe cómo
                  recopilamos, usamos y protegemos tu información personal.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-135">
                  1. Información que recopilamos
                </h3>
                <p data-id="element-136">
                  Recopilamos únicamente la información necesaria para procesar
                  tu compra: nombre, dirección de correo electrónico y datos de
                  pago. No almacenamos datos de tarjetas de crédito en nuestros
                  servidores.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-137">
                  2. Uso de la información
                </h3>
                <p data-id="element-138">
                  Tu información se utiliza exclusivamente para: procesar tu
                  pedido, enviarte el producto digital adquirido y comunicarnos
                  contigo respecto a tu compra.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-139">
                  3. Protección de datos
                </h3>
                <p data-id="element-140">
                  Implementamos medidas de seguridad técnicas y organizativas
                  para proteger tu información personal contra acceso no
                  autorizado, alteración o destrucción.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-141">
                  4. Terceros
                </h3>
                <p data-id="element-142">
                  No vendemos, intercambiamos ni transferimos tu información
                  personal a terceros, excepto a los proveedores de servicios de
                  pago necesarios para completar tu transacción.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-143">
                  5. Tus derechos
                </h3>
                <p data-id="element-144">
                  Podés solicitar acceso, rectificación o eliminación de tus
                  datos personales en cualquier momento.
                </p>
              </div>}

            {modal === 'terms' && <div className="space-y-4 text-warm-dark" data-id="element-145">
                <h2 className="text-2xl font-bold text-chocolate mb-6" data-id="element-146">
                  Términos y Condiciones
                </h2>
                <p data-id="element-147">
                  <strong data-id="element-148">Última actualización:</strong> Abril 2026
                </p>
                <p data-id="element-149">
                  Al adquirir El Paso a Paso del Medio Millón, aceptás los
                  siguientes términos y condiciones de uso.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-150">
                  1. Producto digital
                </h3>
                <p data-id="element-151">
                  Este es un producto digital (Ebook PDF) que se entrega de
                  forma inmediata tras confirmar el pago. Por su naturaleza
                  digital, no se aceptan devoluciones una vez descargado el
                  material.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-152">
                  2. Uso personal
                </h3>
                <p data-id="element-153">
                  El contenido adquirido es para uso personal y exclusivo del
                  comprador. Queda prohibida su reproducción, distribución,
                  reventa o compartición total o parcial sin autorización
                  expresa.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-154">
                  3. Propiedad intelectual
                </h3>
                <p data-id="element-155">
                  Todo el contenido, incluyendo textos, recetas, imágenes,
                  diseños y estrategias, es propiedad intelectual de El Paso a
                  Paso del Medio Millón y está protegido por las leyes de
                  derechos de autor.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-156">
                  4. Resultados
                </h3>
                <p data-id="element-157">
                  Los resultados mencionados son ejemplos ilustrativos. Los
                  ingresos reales dependen del esfuerzo, dedicación y
                  condiciones del mercado de cada persona.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-158">
                  5. Modificaciones
                </h3>
                <p data-id="element-159">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Las modificaciones serán efectivas desde su
                  publicación.
                </p>
              </div>}
          </div>
        </div>}
    </div>;
}